<template>
  <el-dialog
    v-el-drag-dialog
    no="msdApiLogDialog"
    :visible.sync="innerVisible"
    :title="$t('SystemMaintenance.MsdApiLog')"
    :close-on-click-modal="false"
    width="1000px"
    @close="dialogClose"
  >
    <cargo-ag-grid
      config-module="2024032003"
      :grid-options="gridOptions"
      :grid-params.sync="gridParams"
      :column-defs="columnDefs"
      :row-data="rowData"
    />
    <div slot="footer">
      <el-button type="primary" @click="dialogClose()">{{ $t('common.btn.confirm') }}</el-button>
      <el-button @click="dialogClose">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import { getLoading } from '@/utils/utilBaseElement'
import { queryApiReqLog } from '@/api/booking/job'
import DateUtils from '@/utils/dateUtils'

export default {
  name: 'MsdApiLogDialog',
  props: {
    visible: { type: Boolean, default: false },
    data: { type: Object, default: null },
    jobUuid: { type: String, default: '' }
  },
  data() {
    return {
      innerVisible: false,
      loading: false,
      gridParams: {},
      gridOptions: {
        context: {
          componentParent: this
        }
      },
      rowData: []
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_Date'), field: 'DATE_CREATED', colId: 'DATE_CREATED', width: 120,
          cellRenderer: (params) => {
            return DateUtils.formatStandardDateTime(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PushMessage'), field: 'REQUEST_MSG', colId: 'REQUEST_MSG', flex: 1 }
      ]
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (this.visible) {
        this.onShow()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.onShow()
    }
  },
  methods: {
    dialogClose() {
      this.$emit('update:visible', false)
    },
    onShow() {
      this.rowData = []
      if (!this.jobUuid) {
        this.$message.warning(this.$('SeaExport.CheckBusinessUuid'))
        return
      }
      this.loading = getLoading()
      queryApiReqLog(this.jobUuid).then(res => {
        const resultData = []
        for (const tmp of res.data) {
          if (tmp.LOG_SOURCE === 'MSD_SEND_API') {
            resultData.push(tmp)
          }
        }
        this.rowData = resultData
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style scoped>

</style>
